var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * This component represents an unadorned list of SelectItem (s).
 */
import React from 'react';
import { useMultiSelect } from '../hooks/UseMultiSelect';
import SelectItem from './SelectItem';
var SelectList = function (_a) {
    var options = _a.options, onClick = _a.onClick, skipIndex = _a.skipIndex;
    var _b = useMultiSelect(), disabled = _b.disabled, value = _b.value, onChange = _b.onChange, ItemRenderer = _b.ItemRenderer;
    var handleSelectionChanged = function (option, checked) {
        if (disabled)
            return;
        console.log('onChange: ', onChange);
        onChange(checked ? __spreadArray(__spreadArray([], value, true), [option], false) : value.filter(function (o) { return o.value !== option.value; }));
    };
    return (React.createElement(React.Fragment, null, options.map(function (o, i) {
        var tabIndex = i + skipIndex;
        return (React.createElement("li", { key: (o === null || o === void 0 ? void 0 : o.key) || i },
            React.createElement(SelectItem, { tabIndex: tabIndex, option: o, onSelectionChanged: function (c) { return handleSelectionChanged(o, c); }, checked: !!value.find(function (s) { return s.value === o.value; }), onClick: function (e) { return onClick(e, tabIndex); }, itemRenderer: ItemRenderer, disabled: o.disabled || disabled })));
    })));
};
export default SelectList;



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/select-panel/SelectList.tsx
// module id = 1188
// module chunks = 0